import React, { FC, useMemo } from "react";
import { IUserActivityDetails } from ".";
import { AGDialog } from "../../../components/AGDialog";
import { Box, ButtonOwnProps, Grid2, Typography } from "@mui/material";
import moment from "moment";

interface IUserActivityDetailsDialogProps {
	open: boolean;
	activityDetails: IUserActivityDetails | null;
	onClose: () => void;
}

const UserActivityDetailsDialog: FC<IUserActivityDetailsDialogProps> = (props) => {
	const { open, activityDetails, onClose } = props;

	const detailItemClassname = useMemo(
		() => `activity-detail-item ${activityDetails?.type || "low"}`,
		[activityDetails?.type]
	);

	const dialogColor = useMemo<ButtonOwnProps["color"]>(() => {
		switch (activityDetails?.type) {
			case "high":
				return "error";

			case "medium":
				return "warning";

			case "low":
			default:
				return "info";
		}
	}, [activityDetails?.type]);

	return (
		<AGDialog
			open={open}
			onClose={onClose}
			title={`(${activityDetails?.type_text || "Low"}) User Activity Details`}
			color={dialogColor}
		>
			<Grid2 container spacing={2}>
				<Grid2 size={{ xs: 12, md: 4 }}>
					<Box className={detailItemClassname}>
						<Typography variant="body2" color="#00000080" fontWeight={500}>
							Full Name
						</Typography>

						<Typography>{activityDetails?.full_name || "--"}</Typography>
					</Box>
				</Grid2>

				<Grid2 size={{ xs: 12, md: 4 }}>
					<Box className={detailItemClassname}>
						<Typography variant="body2" color="#00000080" fontWeight={500}>
							Username
						</Typography>

						<Typography>{activityDetails?.username || "--"}</Typography>
					</Box>
				</Grid2>

				<Grid2 size={{ xs: 12, md: 4 }}>
					<Box className={detailItemClassname}>
						<Typography variant="body2" color="#00000080" fontWeight={500}>
							Timestamp
						</Typography>

						<Typography>{moment(activityDetails?.timestamp || "").format("DD/MM/YYYY hh:mm A")}</Typography>
					</Box>
				</Grid2>

				<Grid2 size={12}>
					<Box className={detailItemClassname}>
						<Typography variant="body2" color="#00000080" fontWeight={500}>
							Activity
						</Typography>

						<Typography>{activityDetails?.activity || "--"}</Typography>
					</Box>
				</Grid2>
			</Grid2>
		</AGDialog>
	);
};

export default UserActivityDetailsDialog;
